export default __webpack_public_path__ + "static/media/hd-pink-III.71bc4c33.webm";